import { LandingPage } from '../landing/LandingPage';

export function Home() {
  return <LandingPage locale="pt-br" />;
}
